module.exports = __webpack_public_path__ + "img/sem_foto.f891b276.png";